import { render, staticRenderFns } from "./carta-derechos-usuarios.vue?vue&type=template&id=5f18757e&lang=html&"
import script from "./carta-derechos-usuarios.vue?vue&type=script&lang=js&"
export * from "./carta-derechos-usuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports